import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import _ from 'lodash';
import { FC } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useProfileContext } from '../../Contexts/ProfileContext';
import ErrorFallback from '../../ErrorFallback';
import CategoriesAndServices from './components/CategoriesAndServices';
import ServicesWithoutCategories from './components/ServicesWithoutCategories';
import { useStartingRatesState } from './hooks/useStartingRatesState';

const StartingRatesDesktop: FC = () => {
  const { t } = useTranslation();
  const { offeredServices } = useProfileContext();
  const { selectedIndex, handleCategorySelect } = useStartingRatesState();

  if (!offeredServices || _.size(offeredServices) === 0) {
    return null;
  }

  const hasOnlyOneCategory = _.size(offeredServices) === 1;
  const selectedServices = offeredServices?.[selectedIndex]?.services || [];

  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <Box
        direction="vertical"
        dataHook="starting-rates"
        width="100%"
        gap="30px"
      >
        <Text as="h2" size="medium" weight="bold" dataHook="services-header">
          {t('profile-page-services-section-title')}
        </Text>
        {hasOnlyOneCategory ? (
          <ServicesWithoutCategories services={selectedServices} />
        ) : (
          <CategoriesAndServices
            categories={offeredServices || []}
            selectedServices={selectedServices}
            selectedIndex={selectedIndex}
            onCategorySelect={handleCategorySelect}
          />
        )}
      </Box>
    </ErrorBoundary>
  );
};

export default StartingRatesDesktop;
